import { type QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useState } from 'react';

import { ElevationProvider } from '@/shared/elevation/ElevationProvider';

import { createQueryClient } from './queryClient';

/**
 * Wraps the tree in the query client and in the elevated mode prompt (contract v10).
 * Tests pass their own client through the prop.
 */
export function AppProviders({ children, client }: { children: ReactNode; client?: QueryClient }) {
  const [fallbackClient] = useState(createQueryClient);
  return (
    <QueryClientProvider client={client ?? fallbackClient}>
      <ElevationProvider>{children}</ElevationProvider>
    </QueryClientProvider>
  );
}
